<template>
  <div class="section py-0">
    <div class="section">
      <div class="columns">
        <div class="column is-8 is-offset-2">
          <h2 class="title is-4">Neuer Nutzer</h2>
        </div>
      </div>
    </div>
    <div class="section pt-0">
      <div class="columns is-dekstop">
        <div class="column is-8 is-offset-2">
          <UserSimple @submit="newUser" :user="user" :newUser="true" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import UserSimple from '@/components/editUser/UserSimple.vue';

export default {
  name: 'NewUserOrg',
  components: {
    UserSimple,
  },
  computed: {
    ...mapGetters({ meOrg: 'org/me' }),
  },
  data() {
    return {
      user: {
        salutation: null,
        first_name: null,
        last_name: null,
        type: 'user',
        email: null,
        phone: null,
      },
    };
  },
  methods: {
    newUser(user) {
      this.$store.dispatch('user/CREATE', {
        ...user,
        org_id: this.meOrg.id,
      });
    },
  },
};
</script>
